import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import { COUNTY_COORDS, KENYA_CENTER } from "@/data/constants";
import { pinIcon } from "@/components/MapView";

function ClickHandler({ onSet }) {
  useMapEvents({
    click(e) {
      onSet(Number(e.latlng.lat.toFixed(6)), Number(e.latlng.lng.toFixed(6)));
    },
  });
  return null;
}

function Recenter({ county }) {
  const map = useMap();
  useEffect(() => {
    if (county && COUNTY_COORDS[county]) {
      map.setView(COUNTY_COORDS[county], 12);
    }
  }, [county, map]);
  return null;
}

export const MapPicker = ({ lat, lng, county, onChange }) => {
  const hasPin = lat != null && lng != null;
  const center = hasPin ? [lat, lng] : COUNTY_COORDS[county] || KENYA_CENTER;

  return (
    <div data-testid="map-picker" className="relative isolate z-0 h-56 w-full overflow-hidden rounded-xl border border-border/60">
      <MapContainer center={center} zoom={hasPin ? 15 : 12} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ClickHandler onSet={onChange} />
        <Recenter county={county} />
        {hasPin && <Marker position={[lat, lng]} icon={pinIcon} />}
      </MapContainer>
    </div>
  );
};
